<template>
  <li class="report_item_section_li">
    <keep-alive>
      <components :is="componentSelectComputed" :patientInfoProps="patientInfoProps"/>
    </keep-alive>
  </li>
</template>
<script>
    import RomGraphSection from './romChangeMonitoringGraph'
    import ExpertOpinionSection from './expertOpinionSection'
    import ChiefComplainSection from  './chiefComplainSection'
    import {_REPORT_INFO_COMPONENT_NAMES} from "../static";
    import NoSelect from './noSelect'
    export default {
        name: 'ReportItem',
        components: {RomGraphSection, ExpertOpinionSection, NoSelect, ChiefComplainSection},
        props: ['patientInfoProps', 'selectCompNo'],
        data() {
            return {
                selectedComponent : this.componentSelectComputed
            }
        },
        computed: {
            componentSelectComputed() {
                let componentName;
                switch (this.selectCompNo) {
                    case _REPORT_INFO_COMPONENT_NAMES[0].value : {
                        componentName = _REPORT_INFO_COMPONENT_NAMES[0].componentName;
                        break;
                    }
                    case _REPORT_INFO_COMPONENT_NAMES[1].value : {
                        componentName = _REPORT_INFO_COMPONENT_NAMES[1].componentName;
                        break;
                    }
                    case _REPORT_INFO_COMPONENT_NAMES[2].value : {
                        componentName = _REPORT_INFO_COMPONENT_NAMES[2].componentName;
                        break;
                    }
                    default :componentName = 'NoSelect'; break;
                }
                return componentName;
            }
        }
    }

</script>
<style lang="scss">
@import "@/scss/default.scss";
.report_item_section_li {
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  align-items: stretch;

  background: #fff;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.16);
  border-radius: 10px;
  margin: 5px;
  position: relative;
  width: 100%;
	height: initial;
	& .section_wrap {
		@each  $value in $height_fill_available {
			#{height} : #{$value};
		}
	}
}
</style>